export const adminRoute = () => `/admin`